<template>
  <div class="card shadow-sm border border-light" style="min-height: 392px;">
    <div class="card-body pt-3 px-3 pb-2">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <titles text="İcraçılar üzrə bölgü" style="margin: 0;" />
      </div>
      <hr class="my-2" />
      <el-table border :data="executorStats" class="el-table-css" style="width: 100%">
        <el-table-column prop="name" label="İcraçı">
          <template #default="scope">
            <a href="javascript:void(0)" @click="goToExecutorCases(scope.row.name)"
              style="color: #004eb3; text-decoration: underline; font-weight: 600;">
              {{ scope.row.name }}
            </a>
          </template>
        </el-table-column>

        <el-table-column prop="caseCount" label="İş sayı">
          <template #default="scope">
            <span class="fw-bold">{{ scope.row.caseCount }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import Titles from "@/project/Components/Titles.vue";

export default {
  components: { Titles },
  data() {
    return {
      executorStats: [
        { name: "Elvin Əliyev", caseCount: 6 },
        { name: "Kamran Nəsibov", caseCount: 3 },
        { name: "Aysel Həsənova", caseCount: 5 },
        { name: "Murad Orucov", caseCount: 2 }
      ]
    };
  },
  methods: {
    goToExecutorCases(name) {
      const todayStr = new Date().toISOString().split('T')[0];

      this.$router.push({
        path: "/subrogation/list",
        query: {
          searchType: 1,
          searchText: name,
          dateFrom: '1900-01-01',
          dateTo: todayStr
        }
      });
    }



  }
};
</script>

<style scoped></style>
